import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ApplicantIdVerification from './components/ApplicantIdVerification';
import {
    setApplicantScannedId,
    setApplicantTakenPhoto, setVerification,
} from './applicantIderificationActions';

function ApplicantIdVerificationContainer(props) {
    return (
        <ApplicantIdVerification
            setStep={props.setStep}
            setStepCompleted={props.setStepCompleted}
            applicant={props.applicant}
            scannedId={props.scannedId}
            takenPhoto={props.takenPhoto}
            setApplicantScannedId={props.setApplicantScannedId}
            setApplicantTakenPhoto={props.setApplicantTakenPhoto}
            verified={props.verified}
            setVerification={props.setVerification}
            photoUrl={props.photoUrl}
        />
    );
}

const mapStateToProps = state => ({
    applicant: state.applicantIdVerificationReducer.applicant,
    scannedId: state.applicantIdVerificationReducer.scannedId,
    takenPhoto: state.applicantIdVerificationReducer.takenPhoto,
    verified: state.applicantIdVerificationReducer.verified,
    photoUrl: state.applicantIdVerificationReducer.photoUrl,
});

const mapDispatchToProps = dispatch => ({
    setApplicantScannedId: (event) => {
        dispatch(setApplicantScannedId(event));
    },
    setApplicantTakenPhoto: (event) => {
        dispatch(setApplicantTakenPhoto(event));
    },
    setVerification: (event) => {
        dispatch(setVerification(event));
    },
});

ApplicantIdVerificationContainer.propTypes = {
    setStep: PropTypes.func.isRequired,
    setStepCompleted: PropTypes.func.isRequired,
    applicant: PropTypes.object.isRequired,
    scannedId: PropTypes.bool.isRequired,
    takenPhoto: PropTypes.bool.isRequired,
    verified: PropTypes.bool.isRequired,
    setApplicantScannedId: PropTypes.func.isRequired,
    setApplicantTakenPhoto: PropTypes.func.isRequired,
    setVerification: PropTypes.func.isRequired,
    photoUrl: PropTypes.string.isRequired,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(ApplicantIdVerificationContainer);



// WEBPACK FOOTER //
// ./src/app/FormStepper/ApplicantIdVerification/ApplicantIdVerificationContainer.js